import React, {FC} from 'react';
import './style.scss';
import {SwipeableList, SwipeableListItem} from '@sandstreamdev/react-swipeable-list';
import '../../../assets/styles/swipeable-list.scss'
import MixesCard from "../../MixesCard";
import {useHistory} from 'react-router-dom';
import {IMix} from "../../../constants/types";

interface IFavoriteList {
    favorite: Array<any>,
    removeFavoriteMix: any,
    setCurrentMix: any,
    favoriteMixes: Array<IMix>
}

const FavoriteList: FC<IFavoriteList> = ({
                                             favorite,
                                             removeFavoriteMix,
                                             setCurrentMix,
                                             favoriteMixes
                                         }) => {
    const history = useHistory();

    const clickHandler = (id: number) => {
        const mixIndex = favoriteMixes.findIndex((item: { id: number }) => item && item.id === id);
        setCurrentMix(mixIndex);
        history.push(`/favorite/${mixIndex}`);
    };

    return (
        <div className="favorite-list">
            <div className="favorite__cards">
                <SwipeableList>
                    {
                        favorite.map((item: IMix) => {
                            return (
                                <SwipeableListItem
                                    key={item.id}
                                    swipeLeft={{
                                        content: <div className="favorite__remove">Удалить</div>,
                                        action: () => removeFavoriteMix(item.id)
                                    }}
                                >
                                    <MixesCard
                                        clickHandler={() => clickHandler(item.id)}
                                        id={item.id}
                                        imageUrl={item.imageUrl}
                                        name={item.name}
                                        isLiked={item.isLiked}
                                        likeCount={item.likeCount}
                                    />
                                </SwipeableListItem>
                            )
                        })
                    }
                </SwipeableList>
            </div>
        </div>
    )
};

export default FavoriteList;
